import { render, staticRenderFns } from "./prescriptionOne.vue?vue&type=template&id=55e7b414&scoped=true&"
import script from "./prescriptionOne.vue?vue&type=script&lang=ts&"
export * from "./prescriptionOne.vue?vue&type=script&lang=ts&"
import style0 from "./prescriptionOne.vue?vue&type=style&index=0&id=55e7b414&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e7b414",
  null
  
)

export default component.exports